/**
 *  功能使用统计主页面
 *  2019-6-17
 *  Bai.Zhiming
 */
angular.module('featureUsageStatisticsModule', [
    'featureUsageStatisticsRouterModule',
    'featureUsageStatisticsEventModule',
    'featureUsageStatisticsServiceModule',
    'fSortModule'
]).controller('featureUsageStatisticsCtrl', ['$scope', 'featureUsageStatisticsService', '$filter', 'globleParamsSet', '$q', 'trsHttpService', '$state',
    function($scope, featureUsageStatisticsService, $filter, globleParamsSet, $q, trsHttpService, $state) {
        initStatus();
        initData();

        /**
     * [sortCallback description] 排序回调函数
     * @return {[type]} [description]
     */
        $scope.sortCallback = function(type) {
            if (type == 'pv') {
                $scope.status.uvSortStatus = undefined;
            } else {
                $scope.status.pvSortStatus = undefined;
            }
            requestData();
        };
    
        /**
         * [itemShow description] 事件名(按钮+所属页面)展示
         *  @param  {[type]} item [description]
         * @return {[type]} string [description]
         */
        $scope.itemShow = function(item){
            let array = [item.module, item.classify, item.pages, item.operbutton];
            array = array.filter((item_) => !!item_);
            return array.join(' > ');
        };

        /**
         * [intoDetail description] 进入详情
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.intoDetail = function(item) {
            $state.go('manageconfig.logmanage.featureusagestatistics.event', {
                eventid: item.id,
                title: ((item) => {
                    let array = [item.module, item.classify, item.pages, item.operbutton];
                    array = array.filter((item_) => !!item_);
                    return array.join(' > ');
                })(item),
                date: $scope.status.untildate ? ($scope.status.fromdate + ',' + $scope.status.untildate) : ''
            }, { reload: false });
        };

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                classifyData: []
            };
            $scope.data = {};
            $scope.page = {
                'CURRPAGE': 1,
                'PAGESIZE': globleParamsSet.getPageSize(),
                'ITEMCOUNT': 0,
                'PAGECOUNT': 1
            };
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            requestData();
        }

        /**
         * [selectDate description] 选择日期
         * @return {[type]} [description]
         */
        $scope.selectDate = function() {
            $scope.data.pvMap = {};
            $scope.data.uvMap = {};
            if (!$scope.status.untildate) {return;}
            filterDate();
        };

        /**
         * [selectedClassify description] 获取到分类的回调函数
         * @return {[type]} [description]
         */
        $scope.selectedClassify = function() {
            requestData();
        };

        /**
         * 
         * [showSelectedArea description] 选择
         * @return {[type]} [description]
         */
        $scope.showSelectClassify = function(node) {
            let deffer = $q.defer();
            let params = {
                serviceid: 'mlf_buridecode',
                methodname: 'get',
                parentid: angular.isDefined(node.id) ? node.id : 0
            };
            featureUsageStatisticsService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((resp) => {
                deffer.resolve(resp.data);
            });
            return deffer.promise;
        };

        /**
         * [fullTextSearch description] 关键词搜索
         * @return {[type]} [description]
         */
        $scope.fullTextSearch = function($event) {
            if ($event && $event.keyCode != 13) {return;}
            $scope.status.isSearch = $scope.status.keywords != '';
            requestData();
        };

        /**
         * [selectPageNum description] 选择每页大小
         * @return {[type]} [description]
         */
        $scope.selectPageNum = function() {
            requestData();
        };

        /**
         * [pageChanged description] 选页数
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            requestData();
        };

        /**
         * [jumpToPage description] 指定跳转到某一页
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function() {
            $scope.page.CURRPAGE = $scope.status.copyCurrPage;
            requestData();
        };

        /**
         * [requestData description] 请求列表
         * @return {[type]} [description]
         */
        function requestData() {
            let params = handleParams();
            $scope.loadingPromise = featureUsageStatisticsService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((resp) => {
                $scope.data.items = resp.data.content;
                handlPage(resp.data);
                $scope.data.pvMap = {};
                $scope.data.uvMap = {};
                if (!$scope.status.untildate) {return;}
                filterDate();
            });
        }

        /**
         * [filterDate description] 过滤pv、uv日期
         * @return {[type]} [description]
         */
        function filterDate() {
            let params = {
                startdate: $scope.status.fromdate + ' 00:00:00',
                enddate: $scope.status.untildate + ' 23:59:59',
                statids: $scope.data.items.map((item) => item.id).join(','),
                serviceid: 'mlf_buridecode',
                methodname: 'queryopercount'
            };
            $scope.loadingPromise = featureUsageStatisticsService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((resp) => {
                $scope.data.pvMap = resp.data.PV;
                $scope.data.uvMap = resp.data.UV;
            });
        }

        /**
         * [handlPage description] 处理分页参数
         * @return {[type]} [description]
         */
        function handlPage(data) {
            $scope.page = {
                CURRPAGE: data.number + 1,
                ITEMCOUNT: data.totalElements,
                PAGESIZE: data.size,
                PAGECOUNT: data.totalPages
            };
            $scope.status.copyCurrPage = data.number + 1;
        }

        /**
         * [handleParams description] 处理参数
         * @return {[type]} [description]
         */
        function handleParams() {
            let params = {
                serviceid: 'mlf_buridecode',
                methodname: angular.isUndefined($state.params.tenantid) ? 'queryallstat' : 'querytenantstat',
                tenantid: $state.params.tenantid
            };
            if ($scope.status.isSearch) {
                params.keyword = $scope.status.keywords;
            }
            let classifyData = $scope.status.classifyData[0] ? $scope.status.classifyData[0] : [];
            params.module = classifyData[0] ? classifyData[0].parentclassify : '';
            params.classify = classifyData[1] ? classifyData[1].parentclassify : '';
            params.pages = classifyData[2] ? classifyData[2].parentclassify : '';
            params.operbutton = classifyData[3] ? classifyData[3].parentclassify : '';
            params.startPage = $scope.page.CURRPAGE - 1;
            params.pageSize = $scope.page.PAGESIZE;
            if ($scope.status.pvSortStatus !== undefined) {
                params.sort = `operatenumber,${$scope.status.pvSortStatus}`;
            } else if ($scope.status.uvSortStatus !== undefined) {
                params.sort = `uv,${$scope.status.uvSortStatus}`;
            }
            return params;
        }

        /**
         * [bindEvent description] 点击方法名绑定事件
         *
         * @param  {[type]}  item   [item description]
         *
         * @return  {[type]}   [return description]
         */
        $scope.bindEvent = function(item) {
            featureUsageStatisticsService.bindEvent({
                detail: {
                    id: item.id,
                    methodname: item.methodname,
                    module: item.module,
                    classify: item.classify,
                    pages: item.pages,
                    operbutton: item.operbutton
                }
            }).then(function() {
                requestData();
            });
        };
    }
]);
